export default "__VITE_ASSET__b0ac78ff__"